var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSecure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "42px",
    viewBox: "0 0 39 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-secure") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Security",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-183.000000, -2057.000000)",
    fill: "#5BAF5A",
    fillRule: "nonzero",
    id: "Group-37"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(156.000000, 1822.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy-3",
    transform: "translate(0.000000, 205.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.603125,36.8651953 L48.003125,30.301875 C47.605,30.1358437 46.930625,30 46.508125,30 C46.0775,30 45.403125,30.1358437 45.005,30.3025313 L29.405,36.8658516 C27.9498125,37.4714063 27,38.9085938 27,40.4261719 C27,61.5984375 42.3725,72 46.426875,72 C50.651875,72 66,61.4835937 66,40.4261719 C66,38.9085938 65.049375,37.4714063 63.603125,36.8651953 Z M46.426875,68.0625 C38.984375,64.9042969 30.904875,54.9292969 30.904875,40.5082031 C30.904875,40.5041016 30.904875,40.5123047 30.904875,40.5082031 L46.407375,33.9752344 C46.43435,33.9669 46.4676788,33.9504527 46.5109688,33.9424465 L62.1,40.4261719 C62.1,57.1113281 51.895,65.7902344 46.426875,68.0625 Z M41.95,47.0625 C41.95,48.8917969 43.0168125,50.4585938 44.55,51.1976953 L44.55,56.90625 C44.55,57.9972656 45.4275,58.875 46.5,58.875 C47.5725,58.875 48.45,57.9931641 48.45,56.90625 L48.45,51.196875 C49.9831875,50.4579375 51.05,48.8909766 51.05,47.0616797 C51.05,44.5244531 49.0130625,42.4679297 46.5,42.4679297 C43.9869375,42.4679297 41.95,44.5277344 41.95,47.0625 Z",
    id: "icon-secure"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecure);
export default __webpack_public_path__ + "static/media/icon-secure.b836bc1ca84af5a90f1d500276e7021f.svg";
export { ForwardRef as ReactComponent };